import { Table, Tag, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import MasterBinService from '../../services/Shared-Service/MasterBinService';
import LoadingSpin from '../loadingSpin/LoadingSpin';
import { SearchOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router';

const ViewActiveKanban = () => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [seletedLocation, setSelectedLocation] = useState(null);

    const locationMap = {
        'garment_super_market': 'Garment Super Market',
        'dispatch_center': 'Dispatch Center',
        'washing': 'Washing'
    };

    console.log(seletedLocation);


    const getDecodedQueryString = () => {
        setSelectedLocation(decodeURIComponent(location.search.substring(1)));
        // setSearchText((decodeURIComponent(location.search.substring(1))));
        return decodeURIComponent(location.search.substring(1));
    };

    const getFormattedLocation = (text, record) => {
        const location = locationMap[text] || text;

        if (record.movement_status === "In Transit" && record.bin_to) {
            const destinationLocation = locationMap[record.bin_to] || record.bin_to;
            return `${location} - ${destinationLocation}`;
        }

        return location || "No Data";
    };

    useEffect(() => {
        const fetchData = async () => {
            getDecodedQueryString();
            try {
                const response = await MasterBinService.masterBin_get_bins_details();
                console.log("Fetched bin details:", response.data);

                // Group by bin_id and location
                const groupedData = response.data.reduce((acc, item) => {
                    const key = `${item.bin_id}-${item.bin_location}`;

                    if (!acc[key]) {
                        acc[key] = {
                            ...item,
                            po_numbers: new Set([item.po_no]),
                            item_numbers: new Set([item.item_no]),
                            kanban_numbers: new Set([item.kanban_no]),
                            colorSizeDetails: [],
                            calculatedTotalQty: 0
                        };
                    } else {
                        acc[key].po_numbers.add(item.po_no);
                        acc[key].item_numbers.add(item.item_no);
                        acc[key].kanban_numbers.add(item.kanban_no);
                    }

                    if (item.size_qty && item.color) {
                        const sizeQtyObj = JSON.parse(item.size_qty);
                        Object.entries(sizeQtyObj).forEach(([size, qty]) => {
                            const numericQty = parseInt(qty, 10) || 0;
                            acc[key].colorSizeDetails.push({
                                key: `${key}-${item.color}-${size}-${item.kanban_no}`,
                                color: item.color,
                                size,
                                qty: numericQty,
                                kanban_no: item.kanban_no
                            });
                            acc[key].calculatedTotalQty += numericQty;
                        });
                    }

                    return acc;
                }, {});

                const processedData = Object.values(groupedData).map(item => ({
                    ...item,
                    po_no: Array.from(item.po_numbers).filter(Boolean).join(', ') || 'No Data',
                    item_no: Array.from(item.item_numbers).filter(Boolean).join(', ') || 'No Data',
                    kanban_no: Array.from(item.kanban_numbers).filter(Boolean).join(', ') || 'No Data',
                    total_qty: item.calculatedTotalQty || 'No Data',
                    formattedLocation: getFormattedLocation(item.bin_location, item) // Add formatted location
                }));

                setData(processedData);
                setFilteredData(processedData);

            } catch (error) {
                console.error("Error fetching bin details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Search functionality
    useEffect(() => { 
        const filterData = () => {
            if (!searchText && (!seletedLocation || seletedLocation.trim() === "")) {
                setFilteredData(data);
                return;
            }
    
            const searchLower = searchText ? searchText.toLowerCase() : "";
            const selectedLocationLower = seletedLocation ? seletedLocation.toLowerCase() : "";
    
            const filtered = data.filter(item => {
                // Get mapped location for filtering
                const mappedLocation = getFormattedLocation(item.bin_location, item).toLowerCase();
    
                // Search in main fields using searchText
                const mainFieldsMatch = searchText && (
                    String(item.bin_id).toLowerCase().includes(searchLower) ||
                    String(item.po_no).toLowerCase().includes(searchLower) ||
                    String(item.item_no).toLowerCase().includes(searchLower) ||
                    String(item.kanban_no).toLowerCase().includes(searchLower) ||
                    String(item.total_qty).toLowerCase().includes(searchLower) ||
                    mappedLocation.includes(searchLower) ||  
                    String(item.bin_status).toLowerCase().includes(searchLower)
                );
    
                // Search in colorSizeDetails using searchText
                const detailsMatch = searchText && item.colorSizeDetails.some(detail =>
                    String(detail.color).toLowerCase().includes(searchLower) ||
                    String(detail.size).toLowerCase().includes(searchLower) ||
                    String(detail.qty).toLowerCase().includes(searchLower) ||
                    String(detail.kanban_no).toLowerCase().includes(searchLower)
                );
    
                // Filter by seletedLocation if it exists
                const locationMatch = selectedLocationLower
                    ? mappedLocation.includes(selectedLocationLower)
                    : true;
    
                return (mainFieldsMatch || detailsMatch || searchText === "") && locationMatch;
            });
    
            setFilteredData(filtered);
        };
    
        filterData();
    }, [searchText, seletedLocation, data]);

    const columns = [
        {
            title: 'Bin ID',
            dataIndex: 'bin_id',
            key: 'bin_id',
        },
        {
            title: 'PO Number',
            dataIndex: 'po_no',
            key: 'po_no',
        },
        {
            title: 'Item',
            dataIndex: 'item_no',
            key: 'item_no',
        },
        // {
        //     title: 'Kanban No',
        //     dataIndex: 'kanban_no',
        //     key: 'kanban_no',
        // },
        {
            title: 'Total Quantity',
            dataIndex: 'total_qty',
            key: 'total_qty',
            render: (text) => text === 'No Data' ? text : Number(text).toLocaleString()
        },
        {
            title: 'Location',
            dataIndex: 'bin_location',
            key: 'bin_location',
            render: (text, record) => getFormattedLocation(text, record)
        },
        {
            title: 'Status',
            dataIndex: 'bin_status',
            key: 'bin_status',
            render: (text) => text || "No Data"
        },
    ];

    const expandColumns = [
        {
            title: 'Kanban No',
            dataIndex: 'kanban_no',
            key: 'kanban_no',
        },
        {
            title: 'Color',
            dataIndex: 'color',
            key: 'color',
            render: (color) => (
                <Tag color="blue">{color}</Tag>
            )
        },
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
        },
        {
            title: 'Quantity',
            dataIndex: 'qty',
            key: 'qty',
            render: (qty) => Number(qty).toLocaleString()
        },
    ];

    const expandedRowRender = (record) => (
        <Table
            columns={expandColumns}
            dataSource={record.colorSizeDetails}
            pagination={false}
            rowKey="key"
            size='small'
        // summary={(pageData) => {
        //     const total = pageData.reduce((acc, row) => acc + (row.qty || 0), 0);
        //     return (
        //         <Table.Summary.Row>
        //             <Table.Summary.Cell index={0} colSpan={3} className="text-right">
        //                 <strong>Total:</strong>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={1}>
        //                 <strong>{total.toLocaleString()}</strong>
        //             </Table.Summary.Cell>
        //         </Table.Summary.Row>
        //     );
        // }}
        />
    );

    return (
        <>
            {loading ? (
                <LoadingSpin />
            ) : (
                <div>
                    <Input
                        placeholder="Search Here..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        style={{ marginBottom: 16, width: 300 }}
                        allowClear
                    />
                    <Table
                        columns={columns}
                        dataSource={filteredData}
                        expandable={{
                            expandedRowRender,
                        }}
                        rowKey={(record) => `${record.bin_id}-${record.bin_location}`}
                        size='small'
                    />
                </div>
            )}
        </>
    );
};

export default ViewActiveKanban;